import { PickingInfo } from '@deck.gl/core';
import type { DetailGridItem } from '../../shared/components';
import type { Household, HouseholdDetail } from '../../types/global';
import { formatNumberToPounds } from '../../utils/formatters';
import { ClickedMarker, MarkerObject } from './streetview.type';

export const getHouseholdsText = (numberOfHouseholds: number): string => `Number of households: ${numberOfHouseholds}`;

export const getHouseholdKey = ({ clientName, householdReference }: Household): string => JSON.stringify([clientName, householdReference]);

export const normalizeMarker = (info: PickingInfo<MarkerObject>): ClickedMarker | null => {
  const { object } = info;

  if (!object) { return null; }

  if ('households' in object) {
    return { ...info,kind: 'household',object };
  }

  return { ...info,kind: 'ward', object };
};

export const getHouseholdCardItems = (detail: HouseholdDetail): DetailGridItem[] => [
  { label: 'Income after costs', value: formatNumberToPounds(detail.incomeAfterCosts) },
  { label: 'Take Home Income', value: formatNumberToPounds(detail.takeHomeIncome) },
  { label: 'Debt', value: detail.arrearsBalance === null ? null : formatNumberToPounds(detail.arrearsBalance) },
  { label: 'Tenure', value: detail.tenure },
  { label: 'Rent', value: formatNumberToPounds(detail.monthlyRent) },
  { label: 'EPC Rating', value: detail.energyRating ? `Band ${detail.energyRating}` : null },
  { label: 'Household Type', value: detail.householdType },
  { label: 'Work Status', value: detail.economicStatus },
  { label: 'Disability', value: detail.disability },
  { label: 'Children', value: String(detail.numberOfChildren) },
  { label: 'Non Dependents', value: String(detail.numberOfNonDependants) },
  { label: 'Risk Group', value: detail.riskGroup },
];
